import { render, staticRenderFns } from "./BeModal.vue?vue&type=template&id=0d5924f2&scoped=true"
import script from "./BeModal.vue?vue&type=script&lang=js"
export * from "./BeModal.vue?vue&type=script&lang=js"
import style0 from "./BeModal.vue?vue&type=style&index=0&id=0d5924f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5924f2",
  null
  
)

export default component.exports